module.exports = __webpack_public_path__ + "img/logo-en.89177162.png";